export const TRANSLATION_MODEL = "eu.amazon.nova-pro-v1:0";
// Haiku 5.5 kostet auf Bedrock EU ein Zehntel von Haiku 4.5. Es gibt keinen "latest"-Alias:
// ein neues Modell muss hier, in lineupdashboardApiBedrock/custom-policies.json und
// (wegen Thinking) in dessen Handler nachgezogen werden (#4352).
export const GENERAL_MODEL = "eu.anthropic.claude-haiku-5-5";

